import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { EnvironmentService, Features } from '@services/environment.service';
import { ItemsService } from '@scaffold/services/items.service';

@Component({
    selector: 'scaffold-feature-restriction',
    templateUrl: './feature-restriction-select.component.html',
    styleUrl: './feature-restriction-select.component.scss',
    standalone: false
})
export class FeatureRestrictionSelectComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  constructor(
    private environmentService: EnvironmentService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService
  ) {
    super(cdr, renderedService);
  }

  options = Features;
  availableFeatures = [];

  ngOnInit() {
    this.environmentService.getInstanceDetails().subscribe(details => {
      let features;
      if (details.scaffold_features) {
        features = [...details.scaffold_features, details.scaffoldType];
      } else {
        features = [details.scaffoldType];
      }
      if (features?.length > 0) {
        this.availableFeatures = this.options.filter(option =>
          features.includes(option.value)
        );
        this.item.data.forEach(data => {
          this[data.name] = data.value;
        });
      }
    });
  }

  updateSwitch(key: string) {
    this.itemsService.updateValue(this.paramprefix + key, this[key], this.info);
  }
}
